import axios from "axios";
import { Message } from "element-ui";
import store from "@/store/index";
import { baseURL } from "@/const/request_api";
import AndroidInterfaceWrapper from "@/utils/androidInterface.js";

// let _playing = null;

// 创建 axios 实例
const _axios = axios.create({
  baseURL: baseURL,
});

// 请求拦截器
_axios.interceptors.request.use(
  (config) => {
    // 添加请求头信息
    config.headers.token = store.state.user.token;
    config.headers.customer_id = store.state.user.userInfo.customer_id;
    config.headers.device = "pc"; // 根据需要修改设备类型
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
_axios.interceptors.response.use(
  (res) => {
    if (res.data.code === 200) {
      // 请求成功，返回数据
      return res.data;
    } else if (res.data.code === 100001 || res.data.code === 100003) {
      // Token 过期或无效，关闭当前标签页
      // if (_playing) {
      //   return;
      // }
      // _playing = true;
      console.log(
        "--------------------------------------------------------------#res",
        JSON.stringify(res)
      );
      Message.error("用户信息已过期，页面即将关闭!");
      setTimeout(() => {
        store.commit("user/logout"); // 清除用户信息
        // 关闭当前标签页
        window.close();
        // _playing = false;
      }, 3000);
      return Promise.reject(new Error("用户信息已过期，页面已关闭"));
    } else {
      // 其他错误处理
      Message.error(res.data.message);
      return Promise.reject(new Error(res.data.message));
    }
  },
  (error) => {
    // 请求失败处理
    Message.error("接口请求失败");
    return Promise.reject(new Error(error));
  }
);

// 判断是否在安卓设备上
const isAndroid = () => {
  return typeof window.deviceUUID !== "undefined";
};

// 通用请求方法
const request = (options, useAndroid = false, androidConfig = null) => {
  return new Promise((resolve, reject) => {
    try {
      if (useAndroid && isAndroid() && androidConfig) {
        // 安卓设备上的处理逻辑
        const params = JSON.stringify(options.data ?? options.params ?? "");
        AndroidInterfaceWrapper.callAndroidMethod(
          androidConfig,
          params,
          (data) => {
            resolve(JSON.parse(data));
          }
        );
      } else {
        // 普通请求
        _axios(options)
          .then((res) => resolve(res))
          .catch((error) => reject(error));
      }
    } catch (error) {
      console.error("请求过程中出错:", error);
      reject(error);
    }
  });
};

export default request;
export { baseURL };
